import React from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';
import Input from '../../components/input/input';
import Validation from '../../components/validation/validation';
import forgotPasswordImageSrc from '../../assets/images/forgot_password.svg';
/* styles */
import './forgot-password.scss';

class ForgotPasswordPage extends React.PureComponent {
    state = {
        email: this.props.email || ''
    };

    onEmailChange = email => {
        this.setState({ email });
        if (this.hasEmailError) {
            this.form.hideError('Email');
            this.hasEmailError = false;
        }
    };

    componentDidMount() {
        if (this.props.model.errors.length > 0 && this.form) {
            this.form.showError('Email', () => this.props.model.errors.map(e => e.messages).join(';'));
            this.hasEmailError = true;
            this.form.validateAll();
        }
    }

    render() {
        return (
            <AuthWrapper
                heading="Forgot password?"
                goBackUrl={`/Account/Login?returnUrl=${encodeURIComponent(this.props.model.returnUrl || '/')}`}
            >
                <Validation.Form
                    method="post"
                    name="ForgotPassword"
                    ref={(c) => { this.form = c; }}
                >
                    <input type="hidden" name="ReturnUrl" value={this.props.model.returnUrl || ''} />
                    <section className="sten-content__section text-center">
                        <img
                            className="sten-forgot-password__img"
                            src={forgotPasswordImageSrc}
                            alt="ForgotPasswordImage"
                        />
                    </section>
                    <section className="sten-content__section">
                        <p>Enter your email address and we will send you instructions to reset your password.</p>
                    </section>
                    <section className="sten-content__section">
                        <Validation.Wrapper validations={{ required: true, email: true }}>
                            <Input
                                name="Email"
                                className="sten-input--sm"
                                type="text"
                                id="Email"
                                placeholder="Email"
                                value={this.state.email}
                                onChange={this.onEmailChange}
                                showKeyboard
                            />
                        </Validation.Wrapper>
                    </section>
                    <div className="sten-content__separator" />
                    <section className="sten-content__section">
                        <Validation.Button className="btn btn--primary btn--sm col-24">Send</Validation.Button>
                    </section>
                    <input name="__RequestVerificationToken" type="hidden" value={this.props.token} />
                </Validation.Form>
            </AuthWrapper>
        );
    }
}

ForgotPasswordPage.defaultProps = {
    email: ''
};

ForgotPasswordPage.propTypes = {
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any).isRequired,
    email: PropTypes.string
};

export default ForgotPasswordPage;
